import tw from 'tailwind-styled-components';
import { Field } from 'formik';

export const FieldContainer = tw.div`flex flex-col gap-1.5`;
export const Label = tw.label`text-sm font-semibold text-gray-700`;
export const RequiredStar = tw.span`text-red-500`;

export const InputField = tw(Field)`w-full px-4 py-2.5 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-color/30 focus:border-primary-color transition-all duration-200 text-gray-700
  ${({ $error }) => $error ? 'border-red-500 bg-red-50' : 'border-gray-300 hover:border-gray-400'}`;

export const TextAreaField = tw(Field)`w-full px-4 py-2.5 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-color/30 focus:border-primary-color transition-all duration-200 text-gray-700 resize-y min-h-[80px]
  ${({ $error }) => $error ? 'border-red-500 bg-red-50' : 'border-gray-300 hover:border-gray-400'}`;

export const ErrorText = tw.div`text-red-500 text-xs mt-1`;
export const SelectWrapper = tw.div`w-full`;